import { i18nDateToString } from 'modules/core/lib/dates'
import i18n from 'modules/core/lib/i18n'
import { parseDateString } from 'modules/contracts/lib/utils'

type ComparableDate = Date | string | null | undefined

const parseComparableDate = (value: ComparableDate) => {
  if (!value) return null

  if (value instanceof Date) {
    const parsed = parseDateString(i18nDateToString(value, 'backend'))
    return parsed && parsed.isValid() ? parsed : null
  }

  const parsed = parseDateString(value)
  return parsed && parsed.isValid() ? parsed : null
}

type GetFirstPaymentOnValidationErrorParams = {
  firstPaymentOn: ComparableDate
  effectiveOn?: string | null
  minFirstPaymentOn?: ComparableDate
}

export const getFirstPaymentOnValidationError = ({
  firstPaymentOn,
  effectiveOn,
  minFirstPaymentOn,
}: GetFirstPaymentOnValidationErrorParams): string | undefined => {
  const firstPaymentValue = parseComparableDate(firstPaymentOn)

  if (!firstPaymentValue) return undefined

  const effectiveDate = parseComparableDate(effectiveOn)
  const minFirstPaymentValue = parseComparableDate(minFirstPaymentOn)
  const minDate = (effectiveDate ?? minFirstPaymentValue)?.clone().startOf('month')

  if (!minDate || !firstPaymentValue.isBefore(minDate, 'month')) {
    return undefined
  }

  if (effectiveDate) {
    return i18n.t(
      'contract_versions.additional_compensation.errors.first_payment_on_before_contract_effective_month',
      {
        contract_effective_date: i18nDateToString(effectiveDate, 'ui'),
      }
    )
  }

  return i18n.t(
    'contract_versions.additional_compensation.errors.first_payment_on_before_current_month'
  )
}
